export default __webpack_public_path__ + "static/media/yucebey7.5c727980.jpg";